import instance from '../xhrService';

const permitApi = {
  create(permit: any): Promise<any> {
    return instance.post(`/api/permits/create`, permit).then((res) => res.data);
  },

  update(permit: any, id: number): Promise<any> {
    return instance
      .put(`/api/permits/update/${id}`, permit)
      .then((res) => res.data);
  },

  deleteByFileId(fileId: number): Promise<any> {
    return instance
      .delete(`/api/permits/deleteByFileId/${fileId}`)
      .then((res) => res.data);
  },

  getByFileId(fileId: number): Promise<any> {
    return instance
      .get(`/api/permits/getByFileId/${fileId}`)
      .then((res) => res.data);
  },
  getProjectPermitStatus: (projectId: number): Promise<any> => {
    return instance
      .get(`/api/permits/getProjectPermitStatus/${projectId}`)
      .then((res) => res.data);
  },
};

export default permitApi;
